<template>
  <layout>
    <!--城市选择区-->
    <template v-slot:pageLeft>
      <QHleftcity @change="change" @cityLoading="cityLoading" ref="QHleftcity"></QHleftcity>
    </template>
    <!--城市选择区 end-->

    <!--总统计区-->
    <template v-slot:pageTab>
      <div class="headerA flex-center">
        <div class="flex-center-col">
          <font class="fontColor">装修排放</font>
        </div>
      </div>
      <div class="headerB flex-between">
        <div class="flex-center-y">
          <dl class="item">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <p>{{ dataName }}</p>
                <p>装修工地</p>
              </div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.pageCount || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">个</div>
            </dt>
          </dl>
          <dl class="item">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <p>排放总量</p>
                <p>包含往年</p>
              </div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.PFL || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">m³</div>
            </dt>
          </dl>
          <dl class="item">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <p>备案总量</p>
                <p>包含往年</p>
              </div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.BAL || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">m³</div>
            </dt>
          </dl>
        </div>
      </div>
    </template>
    <!--总统计区 end-->

    <!--搜索及功能区-->
    <template v-slot:pageSearch>
      <ul class="tab">
        <li style="width: 220px">
          <Input size="small" v-model="searchMap.keywordA" placeholder="请输入关键词">
            <Select v-model="searchMap.likeNameA" slot="prepend" style="width: 90px">
              <Option value="">查询全部</Option>
              <Option value="100">工地名称</Option>
              <Option value="200">订单编号</Option>
              <Option value="300">运输单位</Option>
              <Option value="400">排放单位</Option>
            </Select>
          </Input>
        </li>
        <li style="width: 250px">
          <QHdatePicker v-model="searchMap.daterange" type="daterange" placeholder="清运开始时间"></QHdatePicker>
        </li>
        <li>
          <Button type="warning" size="small" @click="search">查询</Button>
        </li>
      </ul>
    </template>
    <!--搜索及功能区 end-->

    <!--主体呈现区-->
    <template v-slot:pageContent>
      <QHTable :total="total['pageCount'] || 0" :pageThis="pageThis">
        <Table :columns="columns" :data="list" @on-selection-change="(event) => $tableSeletChange(event, pageThis)" :loading="loading" class="QHTableList">
          <!--分割区-->
          <template slot-scope="{ row }" slot="yundanCount">
            <span class="hotFont13">{{ row.yundanCount }}</span>车
          </template>
          <!--分割区-->

          <!--分割区-->
          <template slot-scope="{ row }" slot="isWorksCount">
            <Tag color="default" v-if="row.isWorksCount == 100">单次运</Tag>
            <Tag color="cyan" v-else-if="row.isWorksCount == 200">多次运</Tag>
            <Tag color="error" v-else>有异常</Tag>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="filingStatus">
            <Tooltip content="请及时备案否则将受到政府处罚" placement="left" v-if="row.filingStatus == -1">
              <Tag color="red" v-if="row.filingStatus == -1">未备案</Tag>
            </Tooltip>
            <Tag color="blue" v-if="row.filingStatus == 100">{{ $state["filingStatus"][row.filingStatus] }} </Tag>
            <Tag color="cyan" v-if="row.filingStatus == 200">{{ $state["filingStatus"][row.filingStatus] }} </Tag>
            <Tag color="red" v-if="row.filingStatus == 300">{{ $state["filingStatus"][row.filingStatus] }} </Tag>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="yunshuOrgCount">
            <Tooltip content="未分配车队无法运输" placement="left" v-if="row.yunshuName == '请分配'">
              <Tag color="red">无</Tag>
            </Tooltip>

            <Tooltip :content="row.yunshuName" placement="left" v-if="row.yunshuName != '请分配'">
              <Tag color="cyan">有</Tag>
            </Tooltip>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="isChuchangweilan">
            <Tag color="cyan" v-if="row.isChuchangweilan == 100">已开启</Tag>
            <Tag color="red" v-if="row.isChuchangweilan == 200">已关闭</Tag>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="isRuchangweilan">
            <Tag color="cyan" v-if="row.isRuchangweilan == 100">已开启</Tag>
            <Tag color="red" v-if="row.isRuchangweilan == 200">已关闭</Tag>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="yunshuOrgCount">
            <Tooltip content="未分配车队无法运输" placement="left" v-if="row.yunshuName == '请分配'">
              <Tag color="red">无</Tag>
            </Tooltip>

            <Tooltip :content="row.yunshuName" placement="left" v-if="row.yunshuName != '请分配'">
              <Tag color="cyan">有</Tag>
            </Tooltip>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="action">
            <Button type="warning" size="small" @click="$refs.detailed.hiPop(row)">详情</Button>
          </template>
        </Table>
      </QHTable>
    </template>
    <!--主体呈现区 end-->

    <!--弹窗组件区-->
    <template v-slot:pageBlock>
      <detailed ref="detailed" @reList="getList()"></detailed>
      <filingEditDetailed ref="filingEditDetailed"></filingEditDetailed>
    </template>
    <!--弹窗组件区 end-->
  </layout>
</template>
<script>
import detailed from "./block/detailed/detailed";
import filingEditDetailed from "../filing/block/detailed/detailed";
export default {
  components: {
    detailed,
    filingEditDetailed,
  },
  data() {
    return {
      //列表配置项(loading加载效果,columns列,list数据,selectedRows选中,total统计项)@@@@@@@@@@@
      list: [],
      loading: false,
      pageThis: this,
      selectedRows: [],
      total: {},
      columns: this.$colFilter([
        {
          title: "订单编号",
          key: "NO",
          width: 140,
          align: "center",
        },
        {
          title: "工地名称",
          key: "name",
          minWidth: 250,
          ellipsis: true,
          tooltip: true,
          resizable: true,
          className: "hotFont13",
        },
        {
          title: "备案量",
          key: "garbageNumberCount",
          width: 100,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            var html1 = this.$xiaoshu(row.beianGarbageNumber)+"m³";
            return h("span", html1);
          },
        },
        {
          title: "已运车",
          key: "yundanCount",
          width: 70,
          align: "center",
          slot: "yundanCount",
        },
        {
          title: "已运方数",
          key: "garbageNumberCount",
          width: 100,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            var html1 = this.$xiaoshu(row.garbageNumberCount)+"m³";
            return h("span", html1);
          },
        },
        {
          title: "垃圾类型",
          key: "garbageTypeName",
          width: 150,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            var html1 = row.garbageTypeName;
            if (!this.$isblank(row.garbageName)) {
              html1 = html1 + "(" + row.garbageName + ")";
            }
            return h("span", html1);
          },
        },
        {
          title: "清运时间",
          key: "emissionTime",
          width: 135,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            let time = this.$timeFmt(row.emissionTime, "YYYY-MM-DD HH:mm");
            return h("span", time);
          },
        },
        {
          title: "所在区域",
          key: "districtName",
          width: 80,
          align: "center",
        },
        {
          title: "所在街道",
          key: "streetName",
          width: 100,
          align: "center",
        },
        {
          title: "客户姓名",
          key: "contactName",
          width: 80,
          align: "center",
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "客户电话",
          key: "contactTel",
          width: 110,
          align: "center",
        },
        {
          title: "排放单位",
          key: "paifangName",
          width: 140,
          align: "center",
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "运输单位",
          key: "yunshuName",
          width: 140,
          align: "center",
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "作业要求",
          key: "isWorksCount",
          width: 80,
          align: "center",
          slot: "isWorksCount",
        },
        {
          title: "出场围栏",
          key: "isChuchangweilan",
          width: 80,
          align: "center",
          slot: "isChuchangweilan",
        },
        {
          title: "卸车围栏",
          key: "isRuchangweilan",
          width: 80,
          align: "center",
          slot: "isRuchangweilan",
        },
        {
          title: "车队",
          key: "yunshuOrgCount",
          width: 45,
          align: "center",
          fixed: "right",
          slot: "yunshuOrgCount",
        },
        {
          title: "备案状态",
          key: "filingStatus",
          width: 80,
          align: "center",
          fixed: "right",
          slot: "filingStatus",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          width: 80,
          slot: "action",
          align: "center",
        },
      ]),

      //搜索配置项@@@@@@@@@@@@@@@@@@@@@@@
      searchMap: {
        likeNameA: "",
        keywordA: "",
        cityteamId: "",
        projectType: 100,
        pageNo: 1,
        pageSize: 25,
      },
      //其他逻辑配置项@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
      dataLoading: false,
      dataName: "",
    };
  },

  // +----------------------------------------------------------------------
  // | mounted
  // +----------------------------------------------------------------------
  mounted() {
    this.$refs.QHleftcity.int();
  },

  methods: {
    // +----------------------------------------------------------------------
    // | 切换数据地址数据
    // +----------------------------------------------------------------------
    change(res) {
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;
      this.dataName = res.name;
      this.dataLoading = false;
    },

    cityLoading(res) {
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;
      this.getList();
    },

    // +----------------------------------------------------------------------
    // | 列表
    // +----------------------------------------------------------------------
    getList() {
      var that = this;
      var https = {
        type: "isPagelist",
        api: this.$api.getProjectList100,
        parameter: this.searchMap,
      };
      this.$httpsApi(https, function () {
        that.dataLoading = true;
      });
    },

    // +----------------------------------------------------------------------
    // | 搜索
    // +----------------------------------------------------------------------
    search(status) {
      if (!this.$isblank(status)) {
        this.searchMap.status = status;
      }
      this.searchMap.pageNo = 1;
      this.getList();
    },
  },
};
</script>
